<script lang="ts">
  import EnvSwitcher from '../shared/EnvSwitcher.svelte';
</script>

<header class="relative overflow-hidden py-16 px-6">
  <!-- Subtle gradient background -->
  <div class="absolute inset-0 bg-gradient-to-b from-accent/5 via-bg-dark to-bg-dark"></div>
  <div class="absolute inset-0 bg-[radial-gradient(ellipse_at_top,var(--color-accent-light),transparent_70%)]"></div>

  <div class="relative max-w-6xl mx-auto text-center">
    <div class="flex justify-center mb-6">
      <EnvSwitcher />
    </div>
    <h1 class="text-3xl sm:text-4xl font-bold text-text-primary mb-3 tracking-tight">
      Campaign Strategist Explorer
    </h1>
    <p class="text-text-secondary text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
      Debug, explore, and monitor the Campaign Strategist pipeline across 8 AWS services. All read-only, all in one place.
    </p>
  </div>
</header>
